import { prefetchOrganisationHierarchy } from "../../../api/organisations";
import type { NavigationItemType } from "../../../root/layout/SidebarMenuItem";
import type { Paths } from "../../../shared/usePrivacyNavigate";
import { OrganisationUnits } from "./OrganisationUnits";

export const route: NavigationItemType["route"] = {
  path: "settings/organisation-units/:tenantId?",
  element: <OrganisationUnits />,
};

export const to = (paths: Paths) => paths.organisationUnits();
export const prefetch = prefetchOrganisationHierarchy;
